import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import us from '../../assets/about-us.svg';
import ru from '../../assets/about-ru.svg';


class PageGroup extends Component {
  constructor (props) {
    super(props);
    this.state = { containerMinHeight: 0 };
  }

  componentDidMount () {
    this.setState({
      containerMinHeight: window.innerHeight - this.container.getBoundingClientRect().top,
    });
  }

  render () {
    const { name, longDescription, pages, displayFooter, footerLinks, baseUrl } = this.props;
    const { containerMinHeight } = this.state;
    const activePageSlug = this.props.activePageSlug || pages[0].slug;
    const activePage = pages.find(s => s.slug === activePageSlug);
    return (
      <div className="page-group-stage" ref={elem => this.container = elem} style={{ minHeight: containerMinHeight }}>
        <div className="title-wrapper">
          <div className="page-group-bg-wrapper">
            {displayFooter && <img className="ru d-none d-lg-block" src={ru} width={420} alt="" />}
            {displayFooter && <img className="us d-none d-lg-block" src={us} width={420} alt="" />}
            <div className="page-group-content-wrapper">
              <header>
                <h2 className="heading-alt mb-3">{name}</h2>
                <div className="mb-3 mb-md-5">
                  <div className="body-copy" dangerouslySetInnerHTML={{ __html: longDescription }} />
                </div>
              </header>
              <div className="row">
                <div className="d-none d-md-block col-md-4">
                  <ul className="page-group-page-list">
                    {pages.map(({ pageTitle, slug }) => (
                      <li key={slug} className={slug === activePageSlug ? 'active' : null}>
                        <Link to={`${baseUrl}/${slug}`}>{pageTitle}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-md-8">
                  <div className="page-group-content d-none d-md-block">
                    <h5 className="text-uppercase mb-2">{activePage.pageTitle}</h5>
                    <hr className="mt-0" />
                    <div className="body-copy" dangerouslySetInnerHTML={{ __html: activePage.pageBody }} />
                  </div>
                  <div className="page-group-content d-md-none">
                    {pages.map(({ pageTitle, slug, pageBody }) => (
                      <div key={slug} className="mb-4">
                        <h5 className="text-uppercase mb-2">{pageTitle}</h5>
                        <hr className="mt-0" />
                        <div className="body-copy" dangerouslySetInnerHTML={{ __html: pageBody }} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {displayFooter ? <Footer links={footerLinks} /> : null}
      </div>
    );
  }
}

PageGroup.propTypes = {
  pageTitle: PropTypes.string,
  longDescription: PropTypes.string,
  displayFooter: PropTypes.bool,
  footerLinks: PropTypes.arrayOf(PropTypes.object),
  pages: PropTypes.arrayOf(PropTypes.object),
  activePageSlug: PropTypes.string,
  baseUrl: PropTypes.string,
};

export default PageGroup;



// WEBPACK FOOTER //
// ./src/components/PageGroup/PageGroup.js